"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnchorOrRouterTarget = exports.isRouterNavTarget = exports.isAnchorNavTarget = void 0;
/** Check if the nav item is an anchor tag (using a 'href' prop) */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isAnchorNavTarget = function (item) {
    return item && item.href !== undefined;
};
exports.isAnchorNavTarget = isAnchorNavTarget;
/** Check if nav item is a react-router NavLink (using a 'to' prop) */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isRouterNavTarget = function (item) {
    return item && item.to !== undefined;
};
exports.isRouterNavTarget = isRouterNavTarget;
/** Check if item is either a NavLink or anchor tag (as opposed to a ReactNode) */
var isAnchorOrRouterTarget = function (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
item) {
    return item && (item.href !== undefined || item.to !== undefined);
};
exports.isAnchorOrRouterTarget = isAnchorOrRouterTarget;
